import request from './axios.config'
import axios from 'axios'
import { collaboratorAddApi, consultLegacyApi } from './apiUrl'

export function addCollaborator(data) {
  return request({
    url: collaboratorAddApi,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function submitLegacyConsult(data) {
  const body = new URLSearchParams(data)
  return axios.post(consultLegacyApi, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export function submitFooterByLocale(locale, form) {
  const isZh = (locale || '').toLowerCase().indexOf('zh') === 0

  if (isZh) {
    return submitLegacyConsult({
      uname: form.uname,
      phone: form.phone,
      remark: form.remark,
      ctid: '6'
    })
  }

  return addCollaborator({
    name: form.uname,
    email: form.phone,
    remark: form.remark
  })
}

export function submitProductConsultByLocale(locale, form) {
  const isZh = (locale || '').toLowerCase().indexOf('zh') === 0

  if (isZh) {
    return submitLegacyConsult({
      uname: form.name,
      phone: form.phone,
      cname: form.company,
      ctid: '6'
    })
  }

  return addCollaborator({
    name: form.name,
    email: form.phone,
    remark: form.company
  })
}

export { consultLegacyApi }
